var _style, _g, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _line, _rect5, _rect6, _line2, _rect7, _line3, _rect8, _path7, _path8, _ellipse3, _rect9, _rect10, _path9, _path10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path11, _path12, _ellipse4, _ellipse5, _rect17, _rect18, _path13, _path14, _rect19, _rect20, _rect21, _rect22, _path15, _path16, _line4, _rect23, _rect24, _line5, _rect25, _line6, _rect26, _path17, _rect27, _rect28, _rect29, _rect30, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path18, _path19, _rect37, _rect38, _rect39, _rect40, _path20, _path21, _line7, _rect41, _rect42, _line8, _rect43, _line9, _rect44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#22382D;enable-background:new    ;}\n\t.st1{fill:#9B9B9B;}\n\t.st2{fill:url(#Path_108_1_);}\n\t.st3{fill:#57B894;}\n\t.st4{fill:url(#Ellipse_7_1_);}\n\t.st5{fill:#F8E71C;}\n\t.st6{fill:url(#Path_110_1_);}\n\t.st7{fill:url(#Rectangle_23_1_);}\n\t.st8{fill:#795548;}\n\t.st9{fill:url(#Path_111_1_);}\n\t.st10{fill:#009688;}\n\t.st11{fill:none;}\n\t.st12{fill:url(#Rectangle_27_1_);}\n\t.st13{fill:url(#Path_112_1_);}\n\t.st14{fill:#FFFFFF;}\n\t.st15{fill:url(#Ellipse_9_1_);}\n\t.st16{fill:url(#Rectangle_31_1_);}\n\t.st17{fill:url(#Rectangle_32_1_);}\n\t.st18{fill:url(#Path_114_1_);}\n\t.st19{fill:#4A4A4A;}\n\t.st20{fill:url(#Rectangle_33_1_);}\n\t.st21{fill:#EEEEEE;}\n\t.st22{fill:url(#Ellipse_10_1_);}\n\t.st23{fill:#263238;}\n\t.st24{fill:url(#Rectangle_39_1_);}\n\t.st25{fill:url(#Path_120_1_);}\n\t.st26{fill:url(#Rectangle_41_1_);}\n\t.st27{fill:url(#Path_121_1_);}\n\t.st28{fill:url(#Rectangle_45_1_);}\n\t.st29{fill:none;stroke:#37474F;stroke-miterlimit:10;}\n\t.st30{fill:url(#Rectangle_49_1_);}\n\t.st31{fill:#F5F5F5;}\n\t.st32{fill:url(#Rectangle_51_1_);}\n\t.st33{fill:url(#Ellipse_12_1_);}\n\t.st34{fill:url(#Ellipse_13_1_);}\n\t.st35{fill:#E6E6E6;}\n\t.st36{fill:url(#Rectangle_53_1_);}\n\t.st37{fill:#FDE657;}\n\t.st38{fill:url(#Path_123_1_);}\n\t.st39{fill:url(#Rectangle_59_1_);}\n\t.st40{fill:url(#Path_124_1_);}\n\t.st41{fill:url(#Rectangle_63_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    transform: "translate(-22.697 -235.497)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(22.682 235.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    className: "st0",
    d: "M495.7,122.83c-28.63,24.3-65.77,22.73-98.32,10.09c-32.54-12.65-62.44-35.16-94.15-51.16 c-25.94-13.21-53.89-22.04-82.72-26.14c-40.41-5.61-85.54,1.24-113.7,40.51c-31.36,43.76-28.95,122.68,4.95,162.82 c17.25,20.43,39.84,30.46,59.54,46.43c19.7,15.97,37.95,42.44,36.27,73.24c-1.55,28.48-19.61,50.38-38.3,64.1 c-14.44,10.61-32.23,22.19-33.97,44.16c-1.68,21.25,13.27,37.91,27.56,47.39c46.59,30.9,104.01,30.6,150.44-0.78 c16.55-11.2,31.76-26.09,49.12-34.81c45.6-22.91,95.84,0.15,144.12,8.59c41.11,7.12,83.36,3.39,122.58-10.82 c23.91-8.56,47.91-21.67,64.71-46.03c12.12-17.58,19.66-39.84,26.74-61.82c7.55-23.43,14.82-47.03,21.79-70.8 c4.18-14.27,8.3-28.81,9.38-44.07c1.96-27.66-6.29-55.01-17.51-78.35c-26.66-55.43-71.57-94.4-120.21-104.3 s-100.09,9.44-137.81,51.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    className: "st1",
    d: "M383.1,357.09c-70.36,0.01-127.41-57.02-127.42-127.38S312.7,102.31,383.06,102.3 c70.36-0.01,127.41,57.02,127.42,127.38c0,0.01,0,0.01,0,0.02C510.4,300.01,453.42,357,383.1,357.09z M383.1,103.54 c-69.68,0-126.16,56.48-126.16,126.16s56.48,126.16,126.16,126.16s126.16-56.48,126.16-126.16 C509.18,160.05,452.74,103.62,383.1,103.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    className: "st1",
    d: "M383.1,328.5c-54.57,0-98.81-44.24-98.81-98.81s44.24-98.81,98.81-98.81 s98.81,44.24,98.81,98.81v0C481.83,284.24,437.64,328.43,383.1,328.5z M383.1,132.13c-53.88,0-97.57,43.68-97.57,97.57 s43.68,97.57,97.57,97.57s97.57-43.68,97.57-97.57C480.6,175.83,436.95,132.19,383.1,132.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    className: "st1",
    d: "M383.1,297.79c-37.61,0-68.1-30.49-68.1-68.1c0-37.61,30.49-68.1,68.1-68.1 c37.61,0,68.1,30.49,68.1,68.1c0,0,0,0,0,0C451.19,267.31,420.7,297.79,383.1,297.79z M383.1,162.83 c-36.93,0-66.86,29.94-66.86,66.86c0,36.93,29.94,66.86,66.86,66.86c36.92,0,66.86-29.93,66.86-66.85 C449.96,192.77,420.02,162.84,383.1,162.83L383.1,162.83L383.1,162.83z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    transform: "translate(68.082 253.262)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_108_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -24.0453,
    y1: 573.6278,
    x2: -22.0321,
    y2: 573.6278,
    gradientTransform: "matrix(15.9 0 0 -33.176 897.7915 19231.9629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    className: "st2",
    d: "M515.47,203.93V167.9h32.01v66.79L515.47,203.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    className: "st3",
    d: "M519.27,206.43v-31.48h23.88v59.73L519.27,206.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_7_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.7273,
    y1: 564.0635,
    x2: -31.7273,
    y2: 562.0504,
    gradientTransform: "matrix(29 0 0 -30 1493.528 17347.541)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    className: "st4",
    cx: 573.44,
    cy: 101.56,
    rx: 29.19,
    ry: 30.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    className: "st5",
    cx: 573.44,
    cy: 101.56,
    rx: 23.15,
    ry: 24.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "f741385e-e577-4271-b030-1aa9bd75830a",
    transform: "translate(0 26.774)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_110_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.1159,
    y1: 550.0655,
    x2: -42.1159,
    y2: 548.0524,
    gradientTransform: "matrix(102.7784 0 0 -108.18 4562.7637 59657.8008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    className: "st6",
    d: "M318.2,211.38c17-19.45,15.01-48.99-4.43-65.99c-1.65-1.44-3.4-2.76-5.23-3.96 c2.9-4.49,4.44-9.72,4.43-15.06c0.37-14.73-11.27-26.96-26-27.33c-12.28-0.31-23.19,7.81-26.41,19.67 c-7.08-12.15-20.06-19.64-34.13-19.69c-22.26,0.25-40.11,18.5-39.86,40.77c-0.01,4.8,0.82,9.56,2.44,14.07 c-0.81-0.06-1.63-0.12-2.44-0.12c-17.87,0.21-32.2,14.85-32.01,32.72c0,1.11,0.05,2.21,0.16,3.31 c-14.69,6.59-24.11,21.23-24.01,37.33c-0.25,22.19,17.54,40.38,39.73,40.64c2.31,0,4.61-0.21,6.87-0.62 c-0.12,1.35-0.19,2.71-0.19,4.11c-0.27,24.9,19.68,45.3,44.58,45.58c9.1,0,17.98-2.85,25.39-8.14 c5.96,5.24,13.62,8.13,21.55,8.14c18.6-0.21,33.51-15.46,33.3-34.06c0-0.81-0.06-1.63-0.12-2.42h0.12 c19.92-0.22,35.89-16.55,35.66-36.47C337.68,230.26,330.2,217.76,318.2,211.38z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "aa86aca2-1def-4b5e-bdbf-3429bf39090e",
    className: "st3",
    d: "M313.05,237.94c15.96-18.25,14.11-45.98-4.14-61.94 c-1.55-1.36-3.19-2.6-4.92-3.72c2.72-4.2,4.16-9.1,4.16-14.11c0.35-13.83-10.58-25.32-24.4-25.66 c-11.53-0.29-21.77,7.34-24.8,18.47c-6.64-11.39-18.82-18.42-32.01-18.48c-20.9,0.24-37.65,17.37-37.42,38.26 c-0.01,4.5,0.77,8.97,2.29,13.21c-0.76-0.06-1.52-0.12-2.29-0.12c-16.77,0.18-30.22,13.91-30.04,30.68c0,0.01,0,0.03,0,0.04 c0,1.05,0.05,2.08,0.15,3.1c-13.79,6.19-22.63,19.93-22.55,35.04c-0.23,20.83,16.46,37.9,37.29,38.14c2.16,0,4.32-0.2,6.45-0.58 c-0.11,1.27-0.18,2.56-0.18,3.85c-0.26,23.37,18.46,42.53,41.83,42.8c8.54,0.01,16.87-2.65,23.83-7.6c5.6,4.9,12.79,7.6,20.23,7.6 c17.46-0.2,31.46-14.51,31.26-31.97c0-0.77-0.06-1.51-0.11-2.27h0.11c18.7-0.21,33.69-15.54,33.48-34.24 C331.35,255.67,324.33,243.92,313.05,237.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_23_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.3886,
    y1: 577.6951,
    x2: -5.3886,
    y2: 575.6819,
    gradientTransform: "matrix(4.828 0 0 -120.095 268.1897 69502.1094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    x: 237.31,
    y: 189.1,
    className: "st7",
    width: 9.72,
    height: 241.77
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    x: 240.08,
    y: 192.49,
    className: "st8",
    width: 4.89,
    height: 238.37
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    x: 231.96,
    y: 240.29,
    transform: "matrix(0.6794 -0.7337 0.7337 0.6794 -94.2803 269.6721)",
    className: "st8",
    width: 59.05,
    height: 4.89
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    x: 218.18,
    y: 260.3,
    transform: "matrix(0.5962 -0.8028 0.8028 0.5962 -140.6868 292.6847)",
    className: "st8",
    width: 4.89,
    height: 51.81
  })), /*#__PURE__*/React.createElement("g", {
    id: "b1e29bf6-85c6-472a-ba69-b630e8d8f49d",
    transform: "translate(54.275 49.261)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_111_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -95.6233,
    y1: 527.6606,
    x2: -95.6233,
    y2: 525.6475,
    gradientTransform: "matrix(91.007 0 0 -90.4977 8979.6973 47871.7031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    className: "st9",
    d: "M202.88,215.77c-6.56-6.98-10.22-16.2-10.23-25.79c0.08-13.45,7.21-25.88,18.78-32.73 c-2.54-3.7-3.89-8.09-3.9-12.57c0.22-12.86,10.83-23.1,23.69-22.89c10.38-0.11,19.6,6.58,22.73,16.48 c6.57-10.33,17.98-16.55,30.22-16.48c19.5,0,35.27,15.27,35.27,34.11c0,4.02-0.74,8.01-2.17,11.77c0.72-0.05,1.43-0.1,2.17-0.1 c15.38-0.26,28.07,11.99,28.33,27.38c0,0.92-0.05,1.84-0.15,2.76c12.76,5.15,21.16,17.47,21.28,31.23 c0,18.78-15.74,33.99-35.19,33.99c-2.04-0.01-4.08-0.19-6.09-0.54c0.1,1.13,0.17,2.27,0.17,3.43c0,21.07-17.68,38.15-39.48,38.15 c-7.99,0.01-15.81-2.35-22.45-6.79c-5.38,4.41-12.13,6.81-19.09,6.79c-16.01,0.27-29.21-12.49-29.49-28.5 c0-0.68,0.05-1.35,0.1-2.02h-0.1c-17.15,0.29-31.29-13.37-31.59-30.52C185.79,231.35,192.45,220.82,202.88,215.77z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "da8ae254-7852-462b-b033-1b79dc847a6a",
    className: "st10",
    d: "M260.36,264.91c-6.27-6.69-9.77-15.52-9.77-24.69 c0.07-12.87,6.9-24.77,17.98-31.32c-2.44-3.55-3.75-7.75-3.75-12.06c0.22-12.31,10.37-22.11,22.67-21.91 c9.93-0.1,18.76,6.3,21.76,15.77c6.28-9.87,17.2-15.82,28.9-15.75c18.66,0,33.79,14.61,33.79,32.64c0,3.85-0.7,7.67-2.07,11.27 c0.68-0.05,1.37-0.1,2.07-0.1c14.72-0.25,26.87,11.48,27.13,26.2c0,0.88-0.04,1.77-0.13,2.64c12.21,4.93,20.25,16.72,20.37,29.89 c0,17.97-15.08,32.56-33.68,32.56c-1.95-0.01-3.9-0.19-5.82-0.52c0.1,1.09,0.16,2.17,0.16,3.29c0,20.17-16.92,36.51-37.79,36.51 c-7.66,0.02-15.15-2.25-21.52-6.51c-5.15,4.23-11.61,6.53-18.27,6.51c-15.32,0.26-27.96-11.95-28.22-27.27 c0-0.65,0.05-1.29,0.1-1.94h-0.1c-16.41,0.28-29.94-12.8-30.23-29.21C243.99,279.82,250.36,269.73,260.36,264.91z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "d827a518-3361-4086-b50f-c6b47e6818cd",
    className: "st11",
    x1: 324.42,
    y1: 226.72,
    x2: 324.42,
    y2: 429.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_27_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.5153,
    y1: 577.7648,
    x2: -2.5153,
    y2: 575.7516,
    gradientTransform: "matrix(5.491 0 0 -100.797 338.05 58362.0156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    x: 318.71,
    y: 226.72,
    className: "st12",
    width: 11.05,
    height: 202.92
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    x: 321.36,
    y: 226.72,
    className: "st8",
    width: 6.11,
    height: 202.92
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "_4a2b3956-f53f-4918-93e5-f7b78a79ae92",
    className: "st11",
    x1: 325.04,
    y1: 287.5,
    x2: 288.8,
    y2: 250.53
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    x: 303.86,
    y: 243.14,
    transform: "matrix(0.7141 -0.7 0.7 0.7141 -100.5761 291.7631)",
    className: "st8",
    width: 6.11,
    height: 51.76
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "_100a92bc-a3f1-4f9a-a93f-0d91ae55d71b",
    className: "st11",
    x1: 325.04,
    y1: 319.26,
    x2: 362.6,
    y2: 292.91
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    x: 320.87,
    y: 303.02,
    transform: "matrix(0.8186 -0.5744 0.5744 0.8186 -113.4352 253.0391)",
    className: "st8",
    width: 45.89,
    height: 6.11
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_112_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.9524,
    y1: 578.6432,
    x2: -41.9524,
    y2: 576.6301,
    gradientTransform: "matrix(146.584 0 0 -102.495 6585.3125 59361.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    className: "st13",
    d: "M572.02,262.32H299.48c-6.22,0-11.27,2.8-11.27,6.26v200.07h295.1V268.58 C583.31,265.12,578.25,262.32,572.02,262.32z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    className: "st14",
    d: "M434.89,147.84L292.72,253.45v207.58h285.2V260.97L434.89,147.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_9_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.888,
    y1: 571.5645,
    x2: -34.888,
    y2: 569.5513,
    gradientTransform: "matrix(31.454 0 0 -31.454 1532.5427 18257.873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    className: "st15",
    cx: 435.18,
    cy: 243.1,
    rx: 31.66,
    ry: 31.66
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_31_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.2866,
    y1: 575.4152,
    x2: -35.2866,
    y2: 573.402,
    gradientTransform: "matrix(27.8 0 0 -27.8 1328.8009 16191.0576)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    x: 319.85,
    y: 304.15,
    className: "st16",
    width: 55.97,
    height: 55.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_32_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.1447,
    y1: 575.4152,
    x2: -32.1447,
    y2: 573.402,
    gradientTransform: "matrix(27.8 0 0 -27.8 1415.0109 16191.0576)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    x: 493.4,
    y: 304.15,
    className: "st17",
    width: 55.97,
    height: 55.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_114_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.2764,
    y1: 575.7581,
    x2: -42.2764,
    y2: 573.745,
    gradientTransform: "matrix(175.75 0 0 -88.944 7864.6973 51458.6875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    className: "st18",
    d: "M265.3,306.12l-7.59-42.4l177.8-136.65l176.01,139.38l-4.88,38.05L435.49,175.34L265.3,306.12 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    className: "st19",
    d: "M265.64,297.6l-5.22-29.3l175.05-136.59l173.33,136.6l-5.25,29.27l-168.11-132.5L265.64,297.6 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_33_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.5607,
    y1: 579.3962,
    x2: -35.5607,
    y2: 577.3831,
    gradientTransform: "matrix(33.979 0 0 -46.476 1643.2129 27021.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    x: 400.69,
    y: 367.47,
    className: "st20",
    width: 68.4,
    height: 93.56
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    x: 402.67,
    y: 369.45,
    className: "st19",
    width: 64.45,
    height: 91.58
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    x: 322.4,
    y: 306.13,
    className: "st1",
    width: 52.01,
    height: 18.38
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    x: 322.4,
    y: 324.5,
    className: "st1",
    width: 52.01,
    height: 33.64
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    x: 495.39,
    y: 306.13,
    className: "st1",
    width: 52.01,
    height: 18.38
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    x: 495.39,
    y: 324.5,
    className: "st1",
    width: 52.01,
    height: 33.64
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    className: "st21",
    d: "M434.89,271.65c15.92,0,28.83-12.91,28.83-28.83l0,0v-0.03h-57.66 c-0.02,15.92,12.88,28.84,28.8,28.86c0,0,0,0,0,0H434.89z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    className: "st1",
    d: "M434.89,213.98c-15.91,0-28.82,12.89-28.83,28.81h57.66 C463.71,226.87,450.81,213.98,434.89,213.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_10_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.6317,
    y1: 583.4177,
    x2: -0.6317,
    y2: 581.4045,
    gradientTransform: "matrix(6.74 0 0 -6.74 456.3928 4065.0989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    className: "st22",
    cx: 452.14,
    cy: 414.96,
    rx: 6.78,
    ry: 6.78
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    className: "st23",
    cx: 452.14,
    cy: 414.96,
    rx: 5.09,
    ry: 5.09
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_39_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -37.0466,
    y1: 586.225,
    x2: -37.0466,
    y2: 584.2119,
    gradientTransform: "matrix(41.279 0 0 -13.478 1963.0103 7980.9033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    x: 392.21,
    y: 447.74,
    className: "st24",
    width: 83.1,
    height: 27.13
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    x: 393.9,
    y: 450,
    className: "st14",
    width: 79.71,
    height: 23.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "_06ed4a51-c0d7-4f18-ace3-f8895d5abf4f",
    transform: "translate(48.323 129.889)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_120_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -87.9292,
    y1: 449.1952,
    x2: -87.9292,
    y2: 447.182,
    gradientTransform: "matrix(47.3801 0 0 -49.874 4393.4697 22361.543)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    className: "st25",
    d: "M266.1,255.28c7.84-8.97,6.92-22.59-2.05-30.42c-0.76-0.66-1.56-1.27-2.4-1.82 c1.34-2.07,2.05-4.48,2.05-6.94c0.17-6.79-5.2-12.43-11.99-12.6c-5.66-0.14-10.69,3.6-12.17,9.07c-3.26-5.6-9.25-9.06-15.74-9.08 c-10.26,0.11-18.49,8.53-18.38,18.79c0,0,0,0,0,0c-0.01,2.22,0.37,4.42,1.12,6.51c-0.37-0.03-0.74-0.06-1.12-0.06 c-8.24,0.09-14.84,6.84-14.75,15.08c-0.01,0.51,0.01,1.02,0.08,1.52c-6.77,3.04-11.11,9.79-11.07,17.21 c-0.11,10.23,8.09,18.61,18.32,18.72c0,0,0,0,0,0c1.06,0,2.12-0.1,3.17-0.29c-0.05,0.62-0.09,1.25-0.09,1.89 c-0.12,11.48,9.08,20.88,20.55,21.02c4.2,0,8.29-1.31,11.7-3.74c2.75,2.41,6.28,3.74,9.94,3.74c8.57-0.11,15.44-7.13,15.35-15.7 c0-0.37-0.03-0.74-0.05-1.11h0.05c9.18-0.11,16.54-7.64,16.44-16.82c0,0,0,0,0,0C275.09,263.98,271.64,258.21,266.1,255.28z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "_78683fa5-7813-42ce-9e3f-16828d09ffb2",
    className: "st3",
    d: "M312.05,385.07c7.36-8.41,6.5-21.2-1.92-28.55 c-0.71-0.62-1.47-1.19-2.26-1.71c1.25-1.94,1.92-4.2,1.92-6.51c0.16-6.37-4.88-11.67-11.26-11.82 c-5.31-0.13-10.03,3.38-11.42,8.51c-3.06-5.25-8.68-8.49-14.76-8.52c-9.63,0.11-17.35,8-17.25,17.64c0,2.08,0.36,4.14,1.06,6.09 c-0.35,0-0.7-0.05-1.06-0.05c-7.73,0.09-13.93,6.43-13.84,14.16c-0.01,0.48,0.01,0.95,0.07,1.43c-6.36,2.85-10.43,9.18-10.4,16.15 c-0.11,9.6,7.59,17.47,17.19,17.58c1,0,1.99-0.09,2.97-0.27c-0.05,0.59-0.08,1.18-0.08,1.77c-0.12,10.77,8.51,19.61,19.28,19.73 c0,0,0,0,0,0c3.94,0,7.78-1.23,10.98-3.52c2.58,2.26,5.9,3.51,9.33,3.52c8.05-0.09,14.5-6.69,14.41-14.74c0,0,0,0,0,0 c0-0.35-0.03-0.7-0.05-1.05h0.05c8.62-0.1,15.53-7.16,15.43-15.78c0,0,0,0,0,0C320.48,393.24,317.24,387.83,312.05,385.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_41_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.9804,
    y1: 579.4007,
    x2: 47.9804,
    y2: 577.3876,
    gradientTransform: "matrix(2.227 0 0 -55.358 172.5253 32155.0723)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    x: 277.14,
    y: 362.56,
    className: "st26",
    width: 4.48,
    height: 111.44
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    x: 278.41,
    y: 364.12,
    className: "st8",
    width: 2.25,
    height: 109.88
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    x: 274.67,
    y: 386.14,
    transform: "matrix(0.6794 -0.7337 0.7337 0.6794 -191.7333 335.6636)",
    className: "st8",
    width: 27.22,
    height: 2.25
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    x: 268.32,
    y: 395.39,
    transform: "matrix(0.5962 -0.8028 0.8028 0.5962 -218.2166 380.7834)",
    className: "st8",
    width: 2.25,
    height: 23.88
  })), /*#__PURE__*/React.createElement("g", {
    id: "_972b0d41-b6e5-4c12-bd64-332f8d6d9bc4",
    transform: "translate(73.355 140.248)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_121_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -111.87,
    y1: 439.3582,
    x2: -111.87,
    y2: 437.3451,
    gradientTransform: "matrix(41.963 0 0 -41.7354 4941.6646 18280.293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    className: "st27",
    d: "M212.94,257.31c-3.03-3.22-4.71-7.47-4.72-11.89c0.04-6.21,3.34-11.93,8.68-15.09 c-1.18-1.71-1.81-3.73-1.81-5.81c0.1-5.93,4.99-10.65,10.92-10.55c0,0,0,0,0,0c4.79-0.06,9.04,3.03,10.48,7.6 c3.03-4.76,8.29-7.63,13.93-7.6c8.84-0.14,16.12,6.9,16.28,15.74c0,1.86-0.34,3.7-1.01,5.44c0.33,0,0.66-0.05,1.01-0.05 c7.09-0.12,12.93,5.53,13.06,12.62c0,0.43-0.02,0.85-0.06,1.27c5.88,2.37,9.75,8.06,9.81,14.4c-0.15,8.81-7.41,15.82-16.22,15.67 c-0.94,0-1.88-0.08-2.81-0.24c0.05,0.54,0.08,1.05,0.08,1.58c-0.17,9.88-8.32,17.75-18.2,17.58c-3.69,0.01-7.3-1.08-10.37-3.13 c-2.49,2.03-5.6,3.13-8.81,3.11c-7.38,0.12-13.47-5.76-13.59-13.14c-0.01-0.31,0.01-0.62,0.05-0.93h-0.05 c-7.9,0.13-14.42-6.16-14.56-14.07C205.06,264.5,208.13,259.64,212.94,257.31z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "b9cc99c1-468f-47c5-9d53-f370b6656f3a",
    className: "st10",
    d: "M287.76,397.5c-2.9-3.09-4.51-7.16-4.52-11.4 c0.03-5.93,3.18-11.42,8.29-14.44c-1.13-1.63-1.73-3.57-1.73-5.56c0.1-5.68,4.78-10.2,10.45-10.1c4.58-0.05,8.65,2.9,10.03,7.27 c2.9-4.56,7.93-7.3,13.33-7.27c8.46-0.14,15.43,6.59,15.58,15.05c0,1.78-0.32,3.54-0.95,5.19c0.31,0,0.63-0.05,0.95-0.05 c6.78-0.11,12.36,5.3,12.48,12.08c0,0.41-0.02,0.82-0.06,1.22c5.63,2.27,9.34,7.71,9.39,13.78c-0.15,8.43-7.1,15.14-15.53,15 c-0.91,0-1.82-0.08-2.71-0.23c0.05,0.5,0.08,1.01,0.08,1.51c-0.17,9.46-7.96,16.99-17.42,16.82c-3.53,0.01-6.99-1.03-9.92-3 c-2.37,1.95-5.35,3-8.42,3c-7.07,0.12-12.9-5.51-13.03-12.57c-0.01-0.3,0.01-0.6,0.05-0.89h-0.05c-7.56,0.13-13.8-5.9-13.94-13.46 C280.17,404.34,283.14,399.7,287.76,397.5z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "_7a451371-7fbb-4ddd-b5af-3dcf3eef4c8e",
    className: "st11",
    x1: 317.29,
    y1: 379.9,
    x2: 317.29,
    y2: 473.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_45_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.4679,
    y1: 579.7957,
    x2: 44.4679,
    y2: 577.7826,
    gradientTransform: "matrix(2.531 0 0 -46.463 204.6563 27020.2852)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    x: 314.66,
    y: 379.9,
    className: "st28",
    width: 5.1,
    height: 93.54
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    x: 315.88,
    y: 379.9,
    className: "st8",
    width: 2.82,
    height: 93.54
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "f8907fab-e671-432b-8785-92f5b3540283",
    className: "st11",
    x1: 317.58,
    y1: 407.92,
    x2: 300.87,
    y2: 390.88
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    x: 307.82,
    y: 387.47,
    transform: "matrix(0.7141 -0.7 0.7 0.7141 -191.1892 330.6542)",
    className: "st8",
    width: 2.82,
    height: 23.86
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "_83bfd14d-9fcf-4efd-aa6d-a51063723d88",
    className: "st11",
    x1: 317.58,
    y1: 422.56,
    x2: 334.89,
    y2: 410.41
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    x: 315.66,
    y: 415.06,
    transform: "matrix(0.8186 -0.5744 0.5744 0.8186 -180.0407 262.9706)",
    className: "st8",
    width: 21.15,
    height: 2.82
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    className: "st29",
    d: "M179.13,345.76l36.66,38.11l41.48-38.11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_49_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.2542,
    y1: 578.9108,
    x2: -32.2542,
    y2: 576.8976,
    gradientTransform: "matrix(12.219 0 0 -75.479 549.3672 43771.8086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    x: 142.95,
    y: 326.47,
    className: "st30",
    width: 24.6,
    height: 151.95
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    x: 144.88,
    y: 329.36,
    className: "st31",
    width: 20.74,
    height: 143.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_51_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.5676,
    y1: 573.3003,
    x2: -41.5676,
    y2: 571.2871,
    gradientTransform: "matrix(73.322 0 0 -13.179 3258.3079 7750.8843)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    x: 136.68,
    y: 332.74,
    className: "st32",
    width: 147.61,
    height: 26.53
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    x: 138.61,
    y: 335.63,
    className: "st31",
    width: 143.75,
    height: 20.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_12_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.9136,
    y1: 562.0392,
    x2: -10.9136,
    y2: 560.0261,
    gradientTransform: "matrix(4.314 0 0 -4.314 202.5768 2629.144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    className: "st33",
    cx: 155.5,
    cy: 345.76,
    rx: 4.34,
    ry: 4.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_13_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.6483,
    y1: 562.0392,
    x2: 2.6483,
    y2: 560.0261,
    gradientTransform: "matrix(4.314 0 0 -4.314 260.3238 2629.144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    className: "st34",
    cx: 271.75,
    cy: 345.76,
    rx: 4.34,
    ry: 4.34
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    className: "st35",
    cx: 155.5,
    cy: 345.76,
    rx: 3.38,
    ry: 3.38
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    className: "st35",
    cx: 271.75,
    cy: 345.76,
    rx: 3.38,
    ry: 3.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_53_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.1309,
    y1: 569.9985,
    x2: -39.1178,
    y2: 569.9985,
    gradientTransform: "matrix(46.247 0 0 -31.388 2074.0762 18304.1641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    x: 171.89,
    y: 381.46,
    className: "st36",
    width: 93.1,
    height: 63.19
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    x: 172.62,
    y: 382.18,
    className: "st37",
    width: 91.65,
    height: 60.78
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    x: 183.23,
    y: 391.83,
    className: "st14",
    width: 64.64,
    height: 5.79
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    x: 195.05,
    y: 403.16,
    className: "st14",
    width: 45.82,
    height: 5.79
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    x: 189.26,
    y: 414.5,
    className: "st14",
    width: 55.47,
    height: 5.79
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    x: 183.95,
    y: 425.84,
    className: "st14",
    width: 64.64,
    height: 5.79
  })), /*#__PURE__*/React.createElement("g", {
    id: "_63650477-b8a1-43d8-a2c1-7cd9fae56092",
    transform: "translate(194.288 140.877)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_123_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -230.0845,
    y1: 438.8217,
    x2: -230.0845,
    y2: 436.8086,
    gradientTransform: "matrix(43.0771 0 0 -45.3418 10282.2822 19831.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    className: "st38",
    d: "M335.69,261.71c-7.12-8.15-6.28-20.54,1.87-27.66c0.69-0.6,1.41-1.15,2.18-1.65 c-1.22-1.88-1.86-4.07-1.86-6.31c-0.17-6.17,4.7-11.31,10.87-11.48c5.16-0.14,9.75,3.27,11.1,8.26 c2.97-5.09,8.41-8.23,14.31-8.25c9.33,0.1,16.81,7.75,16.71,17.08c0,2.01-0.34,4.01-1.02,5.9c0.34,0,0.68-0.05,1.02-0.05 c7.49,0.08,13.49,6.22,13.41,13.71c0.01,0.46-0.01,0.92-0.07,1.38c6.16,2.76,10.1,8.9,10.07,15.65 c0.1,9.3-7.35,16.92-16.65,17.03c-0.97,0-1.93-0.09-2.88-0.26c0.05,0.54,0.08,1.14,0.08,1.72c0.12,10.44-8.25,18.99-18.68,19.11 c0,0,0,0,0,0c-3.81,0-7.54-1.19-10.64-3.4c-2.5,2.19-5.71,3.4-9.04,3.4c-7.8-0.09-14.04-6.48-13.96-14.28 c-0.01-0.34,0.01-0.67,0.05-1.01h-0.05c-8.35-0.1-15.04-6.94-14.95-15.29C327.53,269.62,330.66,264.38,335.69,261.71z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "d9fb3d72-af8e-4f1d-b977-47710d21b422",
    className: "st3",
    d: "M532.14,402.5c-6.69-7.65-5.9-19.27,1.75-25.96 c0.65-0.57,1.33-1.08,2.05-1.55c-1.14-1.76-1.75-3.82-1.74-5.92c-0.16-5.79,4.41-10.62,10.21-10.78 c4.85-0.13,9.15,3.07,10.42,7.76c2.78-4.78,7.89-7.73,13.43-7.75c8.75,0.09,15.77,7.26,15.68,16.01c0,0.01,0,0.02,0,0.03 c0,1.89-0.32,3.76-0.96,5.54c0.32,0,0.63-0.05,0.96-0.05c7.03,0.08,12.66,5.84,12.58,12.87c0.01,0.43-0.01,0.87-0.06,1.3 c5.78,2.59,9.49,8.35,9.46,14.68c0.1,8.73-6.9,15.88-15.63,15.98c0,0,0,0,0,0c-0.91,0-1.82-0.08-2.71-0.24 c0.05,0.54,0.08,1.09,0.08,1.63c0.11,9.79-7.74,17.82-17.54,17.94c-3.58,0-7.07-1.12-9.99-3.2c-2.35,2.06-5.36,3.19-8.48,3.2 c-7.32-0.08-13.18-6.08-13.1-13.4c-0.01-0.32,0.01-0.64,0.05-0.95h-0.05c-7.84-0.09-14.11-6.51-14.03-14.35 C524.48,409.93,527.42,405.01,532.14,402.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_59_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.4281,
    y1: 580.541,
    x2: 127.4281,
    y2: 578.5279,
    gradientTransform: "matrix(2.024 0 0 -50.331 303.9252 29257.957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    x: 559.8,
    y: 382.03,
    className: "st39",
    width: 4.07,
    height: 101.32
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    x: 560.67,
    y: 383.45,
    className: "st8",
    width: 2.05,
    height: 99.9
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    x: 552.72,
    y: 392.18,
    transform: "matrix(0.7337 -0.6794 0.6794 0.7337 -127.424 483.9615)",
    className: "st8",
    width: 2.05,
    height: 24.75
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    x: 560.02,
    y: 421.69,
    transform: "matrix(0.8028 -0.5962 0.5962 0.8028 -139.4676 423.7222)",
    className: "st8",
    width: 21.72,
    height: 2.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "ea5e6e86-8f22-4c0d-a253-147f504d396e",
    transform: "translate(176.465 150.284)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_124_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -211.7573,
    y1: 430.0537,
    x2: -211.7573,
    y2: 428.0405,
    gradientTransform: "matrix(38.158 0 0 -37.944 8428.1426 16238.9111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    className: "st40",
    d: "M379.09,263.57c2.75-2.93,4.28-6.79,4.29-10.81c-0.03-5.64-3.01-10.86-7.87-13.74 c1.06-1.55,1.63-3.4,1.63-5.28c-0.09-5.39-4.54-9.68-9.92-9.59c-4.35-0.04-8.21,2.76-9.52,6.9c-2.75-4.33-7.54-6.94-12.67-6.9 c-8.03-0.14-14.65,6.26-14.79,14.29c0,1.69,0.31,3.36,0.91,4.93c-0.3,0-0.6-0.04-0.91-0.04c-6.45-0.11-11.77,5.02-11.88,11.47 c0,0,0,0,0,0c0,0.39,0.02,0.77,0.06,1.16c-5.35,2.16-8.87,7.32-8.92,13.09c0.14,8,6.74,14.38,14.74,14.25c0,0,0,0,0,0 c0.85,0,1.71-0.07,2.55-0.22c-0.04,0.47-0.07,0.95-0.07,1.44c0.16,8.98,7.56,16.14,16.55,15.99c3.35,0.01,6.63-0.98,9.42-2.85 c2.26,1.87,5.1,2.89,8.03,2.88c6.71,0.11,12.24-5.23,12.36-11.94c0.01-0.28-0.01-0.57-0.04-0.85h0.04 c7.19,0.12,13.11-5.6,13.24-12.79C386.27,270.09,383.47,265.68,379.09,263.57z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "_79f8c247-f548-4c1c-8f49-a16aaa215201",
    className: "st10",
    d: "M554.22,413.81c2.64-2.8,4.12-6.5,4.12-10.35 c-0.03-5.4-2.89-10.38-7.53-13.13c1.02-1.49,1.57-3.25,1.57-5.05c-0.09-5.16-4.34-9.27-9.5-9.18c-4.16-0.04-7.86,2.64-9.12,6.61 c-2.63-4.14-7.21-6.64-12.12-6.61c-7.69-0.13-14.03,6-14.16,13.69c0,1.61,0.29,3.21,0.87,4.72c-0.29,0-0.58-0.04-0.87-0.04 c-6.17-0.11-11.26,4.81-11.36,10.98c0,0.36,0.02,0.72,0.06,1.09c-5.12,2.06-8.49,7.01-8.54,12.53 c0.13,7.66,6.45,13.77,14.11,13.64c0.82,0,1.64-0.07,2.44-0.2c-0.04,0.46-0.06,0.91-0.06,1.38c0.15,8.6,7.24,15.44,15.84,15.3 c3.21,0.01,6.35-0.93,9.02-2.71c2.16,1.76,4.86,2.72,7.65,2.71c6.42,0.1,11.71-5.01,11.83-11.43c0.01-0.27-0.01-0.54-0.04-0.81 h0.04c6.88,0.11,12.55-5.36,12.67-12.24C561.09,420.04,558.41,415.82,554.22,413.81z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "_86901f0c-b7b5-4ba8-942f-e54f281a8bcd",
    className: "st11",
    x1: 527.37,
    y1: 397.8,
    x2: 527.37,
    y2: 482.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_63_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.2219,
    y1: 581.1558,
    x2: 99.2219,
    y2: 579.1426,
    gradientTransform: "matrix(2.302 0 0 -42.244 299.0442 24589.6035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    x: 525.14,
    y: 397.8,
    className: "st41",
    width: 4.63,
    height: 85.04
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    x: 526.09,
    y: 397.8,
    className: "st8",
    width: 2.56,
    height: 85.04
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "_63650f42-d3c3-489e-a647-f3904e46b7bd",
    className: "st11",
    x1: 527.12,
    y1: 423.27,
    x2: 542.3,
    y2: 407.78
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    x: 523.86,
    y: 414.25,
    transform: "matrix(0.7 -0.7141 0.7141 0.7 -136.3386 506.4808)",
    className: "st8",
    width: 21.69,
    height: 2.56
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "_25077b7e-584e-4c29-8c8c-a60ca5d6c1ae",
    className: "st11",
    x1: 527.12,
    y1: 436.58,
    x2: 511.37,
    y2: 425.54
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    x: 517.96,
    y: 421.45,
    transform: "matrix(0.5744 -0.8186 0.8186 0.5744 -131.8808 608.4743)",
    className: "st8",
    width: 2.56,
    height: 19.23
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.de4bb8fcecb625971e88b622f571653f.svg";
export { ForwardRef as ReactComponent };